import axiosInstance from "./axiosInstance";

function isAbortedRequest(error) {
  return (
    error?.code === "ERR_CANCELED" ||
    error?.name === "CanceledError" ||
    error?.name === "AbortError"
  );
}

const filterService = {
  getAllFilters: async () => {
    try {
      const response = await axiosInstance.get("/filters/allActive");
      return response?.data || {};
    } catch (error) {
      if (isAbortedRequest(error)) {
        throw error;
      }
      const message = error?.response?.data?.message || error?.message || "Failed to load filters";
      throw new Error(message);
    }
  },
};

export default filterService;
